import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-university-rankers',
  templateUrl: './university-rankers.component.html',
  styleUrls: ['./university-rankers.component.scss']
})
export class UniversityRankersComponent implements OnInit {

  activeTab: string = '2025-2026';

  rankers = [
    { year: '2025-2026', image: '/assets/img/univ ranker/univ ranker 2025-2026.jpeg' },
    { year: '2024-2025', image: '/assets/img/univ ranker/univ ranker 2024-25.jpeg' },
    { year: '2023-2024', image: '/assets/img/univ ranker/univ ranker 2023-2024.jpeg' }
  ];

  constructor() { }

  ngOnInit() {
  }

  setTab(year: string) {
    this.activeTab = year;
  }

}
